<template>
  <div class="impressao--tamanho_14 impressao--verso">
    <b-container class="impressao_documento--margin-verso">
      <b-row class="mb-1">
        <b-col>
          <div v-if="propTipo === 'casamento'">
            <div v-for="(pessoa, ind) in data.registro.pessoas"
                 :key="ind">
              <div v-if="pessoa.anotacoes.length">
                <h1 class="label-conjuge">
                  {{ pessoa.nome || pessoa.nome_antigo }}
                </h1>
                <fieldset class="fieldset--grey">
                  <legend class="legend">
                    ANOTAÇÕES DE CADASTRO
                  </legend>
                  <b-row v-for="(documento, index) in pessoa.anotacoes"
                         :key="index"
                         class="mb-2">
                    <b-col>
                      <table class="table-verso table-anotacoes bold">
                        <tr>
                          <td v-if="documento.tipo_documento !== 'grupo_sanguineo'">
                            TIPO DOCUMENTO
                          </td>
                          <td v-if="documento.tipo_documento !== 'grupo_sanguineo'">
                            NÚMERO
                          </td>
                          <td v-if="['ctps', 'passaporte'].indexOf(documento.tipo_documento) !== -1">
                            SÉRIE
                          </td>
                          <td v-if="documento.tipo_documento == 'rg'">
                            ORGÃO EMISSOR
                          </td>
                          <td v-if="['ctps', 'rg'].indexOf(documento.tipo_documento) != -1">
                            UF EMISSOR
                          </td>
                          <td v-if="['rg', 'passaporte', 'titulo', 'ctps', 'cnh'].indexOf(documento.tipo_documento) != -1">
                            DATA EMISSÃO
                          </td>
                          <td v-if="documento.tipo_documento == 'grupo_sanguineo'">
                            GRUPO SANGUÍNEO
                          </td>
                        </tr>
                        <tr class="padding-td">
                          <td v-if="documento.tipo_documento !== 'grupo_sanguineo'">
                            {{ documento.tipo || 'N/C' }}
                          </td>
                          <td v-if="documento.tipo_documento !== 'grupo_sanguineo'">
                            {{ documento.numero || 'N/C' }}
                          </td>
                          <td v-if="['ctps', 'passaporte'].indexOf(documento.tipo_documento) !== -1">
                            {{ documento.serie || 'N/C' }}
                          </td>
                          <td v-if="documento.tipo_documento == 'rg'">
                            {{ documento.orgao_emissor || 'N/C' }}
                          </td>
                          <td v-if="['ctps', 'rg'].indexOf(documento.tipo_documento) != -1">
                            {{ documento.uf || 'N/C' }}
                          </td>
                          <td v-if="['rg', 'passaporte', 'titulo', 'ctps', 'cnh'].indexOf(documento.tipo_documento) != -1">
                            {{ filterDate(documento.data_emissao) || 'N/C' }}
                          </td>
                          <td v-if="documento.tipo_documento == 'grupo_sanguineo'">
                            {{ documento.grupo_sanguineo || 'N/C' }}
                          </td>
                        </tr>
                      </table>
                    </b-col>
                  </b-row>
                </fieldset>
              </div>
            </div>
          </div>
          <div v-else-if="data.anotacoes && data.anotacoes.length">
            <fieldset class="fieldset--grey">
              <legend class="legend">
                ANOTAÇÕES DE CADASTRO
              </legend>
              <b-row v-for="(documento, index) in data.anotacoes"
                     :key="index"
                     class="mb-2">
                <b-col>
                  <table class="table-verso table-anotacoes bold">
                    <tr>
                      <td v-if="documento.tipo_documento !== 'grupo_sanguineo'">
                        TIPO DOCUMENTO
                      </td>
                      <td v-if="documento.tipo_documento !== 'grupo_sanguineo'">
                        NÚMERO
                      </td>
                      <td v-if="['ctps', 'passaporte'].indexOf(documento.tipo_documento) !== -1">
                        SÉRIE
                      </td>
                      <td v-if="documento.tipo_documento == 'rg'">
                        ORGÃO EMISSOR
                      </td>
                      <td v-if="['ctps', 'rg'].indexOf(documento.tipo_documento) != -1">
                        UF EMISSOR
                      </td>
                      <td v-if="['rg', 'passaporte', 'titulo', 'ctps', 'cnh'].indexOf(documento.tipo_documento) != -1">
                        DATA EMISSÃO
                      </td>
                      <td v-if="documento.tipo_documento == 'grupo_sanguineo'">
                        GRUPO SANGUÍNEO
                      </td>
                    </tr>
                    <tr class="padding-td">
                      <td v-if="documento.tipo_documento !== 'grupo_sanguineo'">
                        {{ documento.tipo || 'N/C' }}
                      </td>
                      <td v-if="documento.tipo_documento !== 'grupo_sanguineo'">
                        {{ documento.numero || 'N/C' }}
                      </td>
                      <td v-if="['ctps', 'passaporte'].indexOf(documento.tipo_documento) !== -1">
                        {{ documento.serie || 'N/C' }}
                      </td>
                      <td v-if="documento.tipo_documento == 'rg'">
                        {{ documento.orgao_emissor || 'N/C' }}
                      </td>
                      <td v-if="['ctps', 'rg'].indexOf(documento.tipo_documento) != -1">
                        {{ documento.uf || 'N/C' }}
                      </td>
                      <td v-if="['rg', 'passaporte', 'titulo', 'ctps', 'cnh'].indexOf(documento.tipo_documento) != -1">
                        {{ filterDate(documento.data_emissao) || 'N/C' }}
                      </td>
                      <td v-if="documento.tipo_documento == 'grupo_sanguineo'">
                        {{ documento.grupo_sanguineo || 'N/C' }}
                      </td>
                    </tr>
                  </table>
                </b-col>
              </b-row>
            </fieldset>
          </div>
        </b-col>
      </b-row>

      <b-row v-if="!!data.averbacoes_anotacoes && ((propTipo === 'casamento' && data.averbacoes_anotacoes.length > 420) || (propTipo === 'obito' && data.averbacoes_anotacoes.length > 850))"
             class="mb-1">
        <b-col>
          <fieldset class="fieldset--grey">
            <legend class="legend">
              AVERBAÇÕES/ANOTAÇÕES À ACRESCER 
            </legend>
            <div class="font-8 bold uppercase text-break text-justify"
                 v-html="data.averbacoes_anotacoes" />
          </fieldset>
        </b-col>
      </b-row>

      <b-row v-else-if="data.averbacoes && data.averbacoes.length > 950"
             class="mb-1">
        <b-col>
          <fieldset class="fieldset--grey">
            <legend class="legend">
              AVERBAÇÕES/ANOTAÇÕES À ACRESCER
            </legend>
            <div class="font-8 bold uppercase text-justify"
                 v-html="data.averbacoes" />
          </fieldset>
        </b-col>
      </b-row>

      <b-row v-if="verifyExibicao()"
             class="impressao_documento--rodape mt-3 text-center">
        <b-col cols="5"
               class="font--8 pr-1">
          <div style="white-space: nowrap;">
            Oficial de Registro Civil das Pessoas Naturais
            <br>
            {{ data.cartorio && data.cartorio.nome || 'Não consta' }} - {{ data.cartorio && data.cartorio.endereco ? data.cartorio.endereco.uf : 'Não consta' }}
          </div>
          <div class="mt-2">
            {{ data.oficial || 'Não consta' }} - Oficial
          </div>
          <div v-if="data.cartorio"
               class="mt-2">
            {{ data.cartorio.endereco && data.cartorio.endereco.logradouro || 'Não consta' }}, nº {{ data.cartorio.endereco && data.cartorio.endereco.numero || 'Não consta' }} - {{ data.cartorio.endereco && data.cartorio.endereco.bairro || 'Não consta' }}
            CEP: {{ data.cartorio.endereco && data.cartorio.endereco.cep || 'Não consta' }} - Fone: {{ data.cartorio.telefone || 'Não consta' }}
            <br>e-mail: {{ data.cartorio.email || 'Não consta' }}
          </div>
        </b-col>
        <b-col>
          <div>
            O Conteúdo da certidão é verdadeiro. Dou fé.
          </div>
          <div v-if="data.cartorio">
            {{ data.cartorio.endereco && data.cartorio.endereco.cidade || 'Não consta' }} - {{ data.cartorio.endereco && data.cartorio.endereco.uf || 'Não consta' }}, {{ data.data_atual || 'Não consta' }}.
          </div>
          <div>
            <hr class="hr--assinatura">
            <div class="d-inline-flex">
              {{ data.assinante.nome || 'Não consta' }} - {{ data.assinante.cargo || 'Não consta' }}
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import { filterDate } from '@/filters/filters'

  export default {
    name: "VersoImpressao",
    props: {
      data: {type: Object, default: () => ({})},
      propTipo: { type: String, default: () => ({})}
    },
    methods: {
      filterDate (date) {
        return filterDate(date)
      },
      verifyExibicao () {
        if ((this.propTipo === 'casamento') && this.data.averbacoes_anotacoes && this.data.averbacoes_anotacoes.length > 420) {
          return true
        } else if ((this.propTipo === 'obito') && this.data.averbacoes_anotacoes && this.data.averbacoes_anotacoes.length > 850) {
          return true
        } else if ((this.data.averbacoes && this.data.averbacoes.length > 950)) {
          return true
        } else if (this.data.anotacoes && this.data.anotacoes.length) {
          return true
        } else if (this.propTipo === 'casamento' && this.data.registro.pessoas && this.data.registro.pessoas[0].anotacoes && this.data.registro.pessoas[0].anotacoes.length) {
          return true
        } else if (this.propTipo === 'casamento' && this.data.registro.pessoas && this.data.registro.pessoas[1].anotacoes && this.data.registro.pessoas[1].anotacoes.length) {
          return true
        }

        return false
      }
    }
  }
</script>

<style scoped>
  .table-verso td {
    border: 1px solid black;
    padding: 10px 15px;
    font-size: 8px;
    text-align: center;
  }

  .table-anotacoes{
    width: 100%;
    text-transform: uppercase;
  }

  .table .padding-td td{
    vertical-align:top;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .label-conjuge {
    font-size: 18px;
    font-weight: bold;
    padding-top: 10px;
    padding-bottom: 10px;
  }
</style>
